import isEmpty from 'validator/lib/isEmpty';

const editUserSchema = {
  role: {
    type: String,
    required: true,
    validate: {
      message: 'common.choose-role',
      validator: value => !isEmpty(value) && value !== 'common.choose-role',
    },
  },
};

export default editUserSchema;



// WEBPACK FOOTER //
// ./src/schemas/editUser.js